import { styled } from 'stitches.config';

export const BestRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
  position: 'relative',
  backgroundColor: '$secondary-200',
  maxWidth: '420px',
  margin: 'auto',

  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '$6',
    maxWidth: '1200px',
  },
});

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  top: 'unset',
  left: '0px',
  right: '0px',
  bottom: '-50px',
  width: '100px',
  height: '100px',
  margin: 'auto',
  zIndex: 1,

  '@bp2': {
    margin: '0',
    top: '45%',
    bottom: 'unset',
    transform: 'translateY(-50%)',
    width: '140px',
    height: '140px',
  },
});

export const ContentWrapper = styled('div', {
  textAlign: 'center',
  marginTop: '20px',
  marginBottom: '40px',
  maxWidth: '310px',

  '@bp2': {
    margin: 'auto',
    marginTop: 0,
    maxWidth: '100%',
  },
});

export const Title = styled('h2', {
  color: '$quaternary-200',
  fontSize: '$h2',
  fontWeight: '$medium',
  marginBottom: '$2',

  '@bp2': {
    fontSize: '$h1',
  },
});

export const Subtitle = styled('p', {
  color: '$quaternary-200',
  fontSize: '$headline',
  fontWeight: '$regular',
  marginBottom: '$2',

  '@bp2': {
    fontSize: '$h4',
  },
});